import { render, staticRenderFns } from "./hotList.vue?vue&type=template&id=1f545598&scoped=true"
import script from "./hotList.vue?vue&type=script&lang=ts"
export * from "./hotList.vue?vue&type=script&lang=ts"
import style0 from "./hotList.vue?vue&type=style&index=0&id=1f545598&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f545598",
  null
  
)

export default component.exports